module.exports = __webpack_public_path__ + "static/pic2-e6009ed9304da80e00aa57c2cc5c99a1.svg";